// extracted by mini-css-extract-plugin
module.exports = {"root":"LabeledBox_root__ws8cV","label":"LabeledBox_label__zO5Hb"};